module.exports = {
  hubTransfer: {
    type: "API",
    value:
      "/api/v1/debuggers/transfer-hubs?accountId=aId&hubIds=hIds&removeAcls=aclValue",
  },
  askStoreRating: {
    type: "API",
    value: "/api/v1/customers/ask-store-rating?customerId=cId",
  },
  requestStatus: {
    type: "API",
    value: "/api/v1/support/requests",
  },
  dropAccess: {
    type: "API",
    value: "/api/v1/support/drop-access?requestId=rId&operatorEmail=opEmail",
  },
  transferAccess: {
    type: "API",
    value:
      "/api/v1/support/transfer-request?requestId=rId&byOperatorEmail=byEmail&toOperatorEmail=toEmail",
  },
  addChild: {
    type: "API",
    value:
      "/api/v1/support/add-child?requestId=rId&byOperatorEmail=byEmail&childEmail=cEmail",
  },
  removeChild: {
    type: "API",
    value:
      "/api/v1/support/revoke-child?requestId=rId&byOperatorEmail=byEmail&childEmail=cEmail",
  },
  triggerPush: {
    type: "API",
    value: "/api/v1/support/trigger-push",
  },
  acceptOrReject: {
    type: "API",
    value:
      "/api/v1/support/support-action?requestId=rId&isTaken=gValue&operatorEmail=opEmail",
  },
  replacementFw: {
    type: "CMD",
    value: "00 00 33 02 01",
  },
  replace1: {
    type: "API",
    value: "/api/v1/hubs/replace1/fromHubId/with/toHubId/",
  },
  restart: {
    type: "CMD",
    value: "00 00 1e",
  },
  NodeCount: {
    type: "CMD",
    value: "00 00 01 65",
  },
  latestFw: {
    type: "CMD",
    value: "00 00 33 02",
  },
  latestFwStaging: {
    type: "CMD",
    value: "00 00 33 02 02",
  },
  replace2: {
    type: "API",
    value: "/api/v1/hubs/replace2/fromHubId/with/toHubId/",
  },
  replaceNodes: {
    type: "API",
    value: "/api/v1/tools/node-replacement",
  },
  vaSync: {
    type: "API",
    value: "/api/v1/hubs/resync-linked-devices?srcHubId=fId&destHubId=tId",
  },
  syncRoutingInfo: {
    type: "API",
    value: "/api/v1/hubs/syncRoutingInfo/fromHubId/to/toHubId/",
  },
  edgeSync_pro: {
    type: "API",
    value: "/api/v1/hubs/syncWithEdge/toHubId/",
  },
  refreshOtaBucket: {
    type: "API",
    value: "/api/v1/hubmeta/distributions/refresh",
  },
  changeHubRange: {
    type: "CMD",
    value: "00 00 50 00 01 00 00 01",
  },
  changeNodeRange: {
    type: "CMD",
    value: "00 00 50 00 01 00",
  },
  sceneRuleCount_pro: {
    type: "CMD",
    value: "00 00 4a e5",
  },
  clearScenes_pro: {
    type: "CMD",
    value: "00 00 4a e7",
  },
  clearEventRules_pro: {
    type: "CMD",
    value: "00 00 4a e6",
  },
  clearSchRules_pro: {
    type: "CMD",
    value: "00 00 4a e8",
  },
  cleanSync_pro: {
    type: "CMD",
    value: "00 00 4a e9",
  },
  resetHub: {
    type: "CMD",
    // value : '00 00 25 00 02'
    value: "00 00 1e",
  },
  triggerOTA: {
    type: "CMD",
    value: "00 00 33 02",
  },
  requestHealthUpdate: {
    type: "CMD",
    value: "00 00 27",
  },
  realignNetwork: {
    type: "CMD",
    value: "00 00 3b 0f 01",
  },
  forceRemoveNode: {
    type: "CMD",
    value: "00 00 18 00",
  },
  delayModifier: {
    type: "CMD",
    value: "03 00 0E 00 00 00 00 0c 00 00 32",
  },
  deleteAllRepeater: {
    type: "CMD",
    value: "00 00 32",
  },
  toggleRepeater: {
    type: "CMD",
    value: "00 00 30",
  },
};
